// eslint-disable-next-line import/prefer-default-export
export const ACTIONS = [
  {
    name: 'pencil',
    title: 'Edit set',
  }, {
    name: 'projects',
    title: 'Add to a project',
    disabled: true,
  }, {
    name: 'trash',
    title: 'Remove set',
  },
];
